export default function(value) {
  if (!value) {
    return true;
  }
  return /^[-]?\d{1,18}(\.\d{1,2})?$/i.test(value);
}
